import React from "react";
import { CardContainer, CardBackground, CardBody } from "./styled";
import CardHeader from "../CardHeader";

interface CardProps {
  children?: React.ReactNode;
  showHeader?: boolean;
  headerLeft?: React.ReactNode;
  headerRight?: React.ReactNode;
  $customStyles?: any;
}

const Card = ({
  children,
  showHeader = false,
  headerLeft,
  headerRight,
  $customStyles,
}: CardProps) => {
  return (
    <CardContainer sx={$customStyles}>
      <CardBackground />
      {showHeader && (
        <CardHeader left={headerLeft} right={headerRight} />
      )}
      <CardBody>{children}</CardBody>
    </CardContainer>
  );
};

export default Card;
